import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';

const VideoProgressBar = ({ currentFrame, totalFrames, onSeek }) => {
  const progressRef = useRef(null);
  const sliderHandleRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const sliderElement = sliderHandleRef.current;
    const progressElement = progressRef.current;
    if (sliderElement && progressElement && totalFrames > 0) {
      const percent = (currentFrame / totalFrames) * 100;
      sliderElement.style.left = `${percent}%`;
    }
  }, [currentFrame, totalFrames]);

  const handleSeek = (e) => {
    const progressBar = progressRef.current;
    const rect = progressBar.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    const frame = Math.round(percent * totalFrames);
    onSeek(frame);
  };

  const handleMouseMove = (e) => {
    const progressBar = progressRef.current.getBoundingClientRect();
    const percent = (e.clientX - progressBar.left) / progressBar.width;
    const frame = Math.round(percent * totalFrames);
    tooltipRef.current.style.display = 'block'; // Show tooltip
    tooltipRef.current.style.left = `${e.clientX - progressBar.left}px`;
    tooltipRef.current.innerText = `${frame}`;
  };

  const handleMouseLeave = () => {
    tooltipRef.current.style.display = 'none';
  };

  return (
    <Box
      sx={{
        bgcolor: '#ccc',
        position: 'relative',
        height: '20px',
        width: '100%',
        my: 2,
        cursor: 'pointer'
      }}
      onClick={handleSeek}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <Box ref={progressRef}></Box>
      <Box
        ref={sliderHandleRef}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '8px',
          bgcolor: '#00A1DF',
          cursor: 'pointer'
        }}
      ></Box>
      <Box
        ref={tooltipRef}
        sx={{
          position: 'absolute',
          top: '-35px',
          pointerEvents: 'none',
          color: 'white',
          bgcolor: 'rgba(0, 0, 0, 0.75)',
          padding: '5px',
          borderRadius: '5px',
          display: 'none',
          transform: 'translateX(-50%)',
          whiteSpace: 'nowrap'
        }}
      ></Box>
    </Box>
  );
};

export default VideoProgressBar;